import i18n from '@/i18n/index';
import { formatDate } from '@/services/general/general';

function getInfoDateDemontage(item) {
  if (!item.dateDemontage) return '';
  return `${i18n.t('ajoutProduitExistant.dateDemontage')} ${formatDate(item.dateDemontage)}`;
}

export function produitFaceForRecomToProduitFaceMapper(item) {
  return {
    id: item.id,
    infoDateDemontage: getInfoDateDemontage(item),
    tiers: !item.tiersId ? null : { id: item.tiersId, nomCommercial: item.tiersNomCommercial },
    referenceConfrere: item.referenceConfrere,
    produitFace: {
      codePanneau: item.codePanneau,
      azimut: item.azimut,
      format: item.format,
      materielType: item.materielType,
      dateDemontage: item.dateDemontage,
      disposition: item.disposition,
      adresse: {
        adresse1: item.adresse1,
        adresse2: item.adresse2,
        adresse3: item.adresse3,
        intitule1: item.intitule1,
        intitule2: item.intitule2,
        intitule3: item.intitule3,
        pays: item.pays,
        ville: item.ville,
        codePostal: item.codePostal,
        departement: item.departement,
        agglomeration: item.agglomeration,
        latitude: item.latitude,
        longitude: item.longitude,
        coordonnees: null,
      }
    },
    categorieVente: item.categorieVente,
  };
}
